import Api from "@/helpers/api.js";
export default {
	namespaced: true,
	state: () => ({
		uploadedFiles: [],
		uploadedFilesIds: [],
		uploadProgress: 0,
		currentUpload: null,
		equivalents: null,
		showUploadFile: true,
		showSetEquivalence: false,
		uploadedInfo: null,
		showSetEquivalenceOptimization: false,
		showUploadFileOptimization: true,
		uploadedInfoTemporal: null,
		showUploadFileOptimizationVehicle: true,
	}),
	actions: {
		saveUploadFile: ({commit}, payload) => {
			return new Promise((resolve, reject) => {
				Api.post("/upload", payload)
					.then((response) => {
						commit("SET_UPLOADED_INFO", {...payload, ...response.data});
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		uploadValidateVisitPoint: ({commit}, payload) => {
			return new Promise((resolve, reject) => {
				Api.put(`/uploadvalidate/visit_point/${payload.id}`, payload.body)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		uploadValidateVehicle: ({commit}, payload) => {
			return new Promise((resolve, reject) => {
				Api.put(`/uploadvalidate/vehicle/${payload.id}`, payload.body)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		downloadFileFormat: ({commit}, payload) => {
			return new Promise((resolve, reject) => {
				Api.post("/download/base/file", payload)
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		getUploadFilter: (
			{commit},
			payload = {
				page: 1,
				quantity: 1000000,
				id: [],
				category_id: null,
				process_state: "FINALIZED",
				order_by: "added_on",
				sort: "DESC",
			}
		) => {
			return new Promise((resolve, reject) => {
				Api.post("/upload/filter", payload)
					.then((response) => {
						commit("addUploadedFiles", response.data.records);
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		removeUploadFile: ({commit}, idFile) => {
			return new Promise((resolve, reject) => {
				Api.delete("/upload/" + idFile)
					.then((response) => {
						commit("REMOVE_UPLOAD_FILE_ITEM", idFile);
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		uploadFileServive: ({commit}, formData) => {
			return new Promise((resolve, reject) => {
				Api.upload("/upload/file", formData)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		cartoimport: ({commit}, payload) => {
			return new Promise((resolve, reject) => {
				Api.post("/cartoimport", payload)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		saveUploadFileTemporal: ({commit}, payload) => {
			return new Promise((resolve, reject) => {
				Api.post("/upload_temporal", payload)
					.then((response) => {
						commit("SET_UPLOADED_INFO_TEMPORAL", {...payload, ...response.data});
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
	},
	mutations: {
		incrementProgress(state, progress) {
			// `state` is the local module state
			state.uploadProgress = progress;
		},
		resetProgress(state) {
			// `state` is the local module state
			state.uploadProgress = 0;
		},
		addUploadedFiles(state, uploadedFiles) {
			state.uploadedFiles = uploadedFiles;
		},
		REMOVE_UPLOAD_FILE_ITEM(state, itemId) {
			const ItemIndex = state.uploadedFiles.findIndex((el) => el.id === itemId);
			state.uploadedFiles.splice(ItemIndex, 1);
		},
		SAVE_UPLOAD(state, data) {
			state.currentUpload = data;
		},
		SET_EQUIVALENTS(state, data) {
			state.equivalents = data;
		},
		SET_SHOW_UPLOAD_FILE(state, val) {
			state.showUploadFile = val;
		},
		SET_SHOW_EQUIVALENCES(state, val) {
			state.showSetEquivalence = val;
		},
		SET_UPLOADED_INFO(state, info) {
			state.uploadedInfo = info;
		},
		SET_UPLOADED_INFO_TEMPORAL(state, info) {
			state.uploadedInfoTemporal = info;
		},
		ADD_ID_UPLOAD_FILES(state, id) {
			state.uploadedFilesIds.push(id);
		},
		REMOVE_ID_UPLOAD_FILES(state, item) {
			const itemIndex = state.uploadedFilesIds.findIndex((p) => p.id === item.id);
			if (itemIndex >= 0) {
				state.uploadedFilesIds.splice(itemIndex, 1);
			}
		},
		SET_SHOW_UPLOAD_FILE_OPTIMIZATION(state, val) {
			state.showUploadFileOptimization = val;
		},
		SET_SHOW_UPLOAD_FILE_OPTIMIZATION_VEHICLE(state, val) {
			state.showUploadFileOptimizationVehicle = val;
		},
		SET_SHOW_EQUIVALENCES_OPTIMIZATION(state, val) {
			state.showSetEquivalenceOptimization = val;
		},
	},
	getters: {
		uploadedInfo: (state) => state.uploadedInfo,
	},
};
